/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCharactersCharacterIdClonesJumpClone } from './GetCharactersCharacterIdClonesJumpClone';
import {
    GetCharactersCharacterIdClonesJumpCloneFromJSON,
    GetCharactersCharacterIdClonesJumpCloneFromJSONTyped,
    GetCharactersCharacterIdClonesJumpCloneToJSON,
    GetCharactersCharacterIdClonesJumpCloneToJSONTyped,
} from './GetCharactersCharacterIdClonesJumpClone';
import type { GetCharactersCharacterIdClonesHomeLocation } from './GetCharactersCharacterIdClonesHomeLocation';
import {
    GetCharactersCharacterIdClonesHomeLocationFromJSON,
    GetCharactersCharacterIdClonesHomeLocationFromJSONTyped,
    GetCharactersCharacterIdClonesHomeLocationToJSON,
    GetCharactersCharacterIdClonesHomeLocationToJSONTyped,
} from './GetCharactersCharacterIdClonesHomeLocation';

/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdClonesOk
 */
export interface GetCharactersCharacterIdClonesOk {
    /**
     * 
     * @type {GetCharactersCharacterIdClonesHomeLocation}
     * @memberof GetCharactersCharacterIdClonesOk
     */
    homeLocation?: GetCharactersCharacterIdClonesHomeLocation;
    /**
     * jump_clones array
     * @type {Array<GetCharactersCharacterIdClonesJumpClone>}
     * @memberof GetCharactersCharacterIdClonesOk
     */
    jumpClones: Array<GetCharactersCharacterIdClonesJumpClone>;
    /**
     * last_clone_jump_date string
     * @type {Date}
     * @memberof GetCharactersCharacterIdClonesOk
     */
    lastCloneJumpDate?: Date;
    /**
     * last_station_change_date string
     * @type {Date}
     * @memberof GetCharactersCharacterIdClonesOk
     */
    lastStationChangeDate?: Date;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdClonesOk interface.
 */
export function instanceOfGetCharactersCharacterIdClonesOk(value: object): value is GetCharactersCharacterIdClonesOk {
    if (!('jumpClones' in value) || value['jumpClones'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdClonesOkFromJSON(json: any): GetCharactersCharacterIdClonesOk {
    return GetCharactersCharacterIdClonesOkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdClonesOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdClonesOk {
    if (json == null) {
        return json;
    }
    return {
        
        'homeLocation': json['home_location'] == null ? undefined : GetCharactersCharacterIdClonesHomeLocationFromJSON(json['home_location']),
        'jumpClones': ((json['jump_clones'] as Array<any>).map(GetCharactersCharacterIdClonesJumpCloneFromJSON)),
        'lastCloneJumpDate': json['last_clone_jump_date'] == null ? undefined : (new Date(json['last_clone_jump_date'])),
        'lastStationChangeDate': json['last_station_change_date'] == null ? undefined : (new Date(json['last_station_change_date'])),
    };
}

export function GetCharactersCharacterIdClonesOkToJSON(json: any): GetCharactersCharacterIdClonesOk {
    return GetCharactersCharacterIdClonesOkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdClonesOkToJSONTyped(value?: GetCharactersCharacterIdClonesOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'home_location': GetCharactersCharacterIdClonesHomeLocationToJSON(value['homeLocation']),
        'jump_clones': ((value['jumpClones'] as Array<any>).map(GetCharactersCharacterIdClonesJumpCloneToJSON)),
        'last_clone_jump_date': value['lastCloneJumpDate'] == null ? undefined : ((value['lastCloneJumpDate']).toISOString()),
        'last_station_change_date': value['lastStationChangeDate'] == null ? undefined : ((value['lastStationChangeDate']).toISOString()),
    };
}

